import { render } from "./CrearReceta.vue?vue&type=template&id=073c8579&scoped=true"
import script from "./CrearReceta.vue?vue&type=script&lang=js"
export * from "./CrearReceta.vue?vue&type=script&lang=js"

import "./CrearReceta.vue?vue&type=style&index=0&id=073c8579&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073c8579"]])

export default __exports__